module.exports = __webpack_public_path__ + "static/media/authentication-photo.77a9d030.svg";